import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, useStore } from "react-redux";
import currentProductMiddleware from "@/redux/middleware/current-product-middleware.ts";
import filterCombinationsMiddleware from "@/redux/middleware/filter-combinations-middleware.ts";
import smartNumberDiagnosticsMiddleware from "@/redux/middleware/smart-number-diagnostics-middleware.ts";
import smartNumberMiddleware from "@/redux/middleware/smart-number-middleware.ts";
import technicalDrawingMiddleware from "@/redux/middleware/technical-drawing-middleware.ts";
import crmSlice from "@/redux/slices/crm-slice.ts";
import downloadsSlice from "@/redux/slices/downloads-slice.ts";
import itemListSlice from "@/redux/slices/item-list-slice.ts";
import filterOptionsSlice from "./slices/filter-options-slice.ts";
import installationsSlice from "./slices/installations-slice.ts";
import modelSlice from "./slices/model-slice.ts";
import partsSlice from "./slices/parts-slice.ts";
import productsSlice from "./slices/products-slice.ts";
import smartNumberSlice from "./slices/smart-number-slice.ts";
import subFamilySlice from "./slices/sub-family-slice.ts";

export const makerStore = () => {
    return configureStore({
        reducer: combineReducers({
            crm: crmSlice,
            downloads: downloadsSlice,
            itemList: itemListSlice,
            filterOptions: filterOptionsSlice,
            installations: installationsSlice,
            model: modelSlice,
            parts: partsSlice,
            products: productsSlice,
            smartNumber: smartNumberSlice,
            subFamily: subFamilySlice,
        }),
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware().concat(
                currentProductMiddleware,
                smartNumberMiddleware,
                smartNumberDiagnosticsMiddleware,
                filterCombinationsMiddleware,
                technicalDrawingMiddleware,
            );
        },
        devTools: {
            name: "Deltalight 3D Configurator",
        },
    });
};

export type AppStore = ReturnType<typeof makerStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export const useAppStore = useStore.withTypes<AppStore>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
